export const getAvatarInitials = (name: string): string => {
  const [a, b] = name.split(' ') as [string, string | undefined];
  return b ? a[0] + b[0] : a[0];
};
